import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { loadNotification } from '../actions';


class NotificationDetail extends Component {
  componentWillReceiveProps(nextProps) {
    if(nextProps.params.id != this.props.params.id) {
    this.props.loadNotification(nextProps.params.id);
    }
  }

  componentWillMount() {
    this.props.loadNotification(this.props.params.id);
  }

  render() {
    const notification = this.props.notificationDetail;
    let content = 'loading...';

    if(!notification) {
      return <span></span>;
    }

    return <div className="notificationDetail-inner">
      <Link to="/notifications" className="notifications-pageTitle"><i className="fa fa-chevron-left"></i> Notification</Link>
      <div className="notificationDetail-notificationDetail">
        <div className="notificationDetail-timestamp">{notification.timeago} </div>
        <div className="notificationDetail-pageTitle">{notification.title}</div>
        <div className="notificationDetail-content">
          {content}
        </div>
      </div>
    </div>;

  }
}


function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadNotification
  }
)(NotificationDetail);



// WEBPACK FOOTER //
// ./src/containers/NotificationDetail.jsx